import React from "react";
import ReactECharts from 'echarts-for-react'; // ECharts wrapper for React
import close from "../../minimise_button.png";
import moment from "moment";
import { min, sortBy } from "lodash";
import * as echarts from 'echarts'; // Import ECharts
import download from "./downloadCSV.jpg";



class GradientChart extends React.Component {

  constructor(props) {
    super(props);
    

    this.state = {
      height: Math.min(360, window.innerHeight * 0.9), // Initial height

      options: {
 
        title: {
          text: this.props.rname[0],
          subtext: this.props.rname[1],
          textStyle: {
            fontSize: 16,
            color: '#0000ff',

          },
          subtextStyle: {
            fontSize: 14,
            color: '#0000ff',

          },
          textAlign: 'center',  // Centering the title
          subtextAlign: 'center',  // Centering the subtext
          x: 'center',  // Horizontal position of the title (centered)
          y: 'top'  // Vertical position of the title (adjust as needed)
        },
       
        tooltip: {
          trigger: 'axis',
         
        },
           
        grid: {
          top: '15%',
          bottom: '20%',
          left: '10%',
          right: '23%',
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
        ],
       
        xAxis: {
          type: 'time',
          name:"Date",
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },

          axisLabel: {
            formatter: (value) => {
              return moment(value).format('DD MMM YYYY');
            },
           

          },
          splitLine: {
            show: false, // Hides vertical grid lines
          },
        },
        yAxis: {
          type: 'value',
          name: 'Inflow (Cusecs)',
          position: "left",
          nameLocation: "middle",
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },

          nameGap: 50,
          min: 0,
          max: Math.max(...this.props.flow_returnPer)*1.025,
          axisLabel: {
            formatter: (value) => value.toFixed(0)
          },
        },
        toolbox: {
          show: true,
          feature: {
          
            magicType: {
              type: ["bar", "line"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            saveAsImage: {
              type: ["png", "svg"],
              title: "Save Chart",
              name: `${this.props.rname[1]
                .split("(")[0]
                .replace(" ", "_")}_ISI_${this.props.date}`,
            },
            myExportCSV: {  // Custom CSV button
              show: true,
              title: "Export to CSV",
              icon: `image://${download}`,  // You can replace this with the path to your custom icon
              onclick: this.exportToCSV,
            },
            // dataView: {
            //   readOnly: true,
            //   title: "View Data",
            //   lang: [`${this.props.title}`, "Close", "Refresh"],
            // },
          },
      
        },

  
        series: [{
          name: 'Streamflow (ft³/s)',
          data: this.props.data,
          type: 'line',
          smooth: true,  // Makes the line smooth
          symbol: 'none',  // No markers (data points)

          lineStyle: {
            width: 3,
            // Apply gradient color to the line
            color: new echarts.graphic.LinearGradient(
              0, 0, 1, 0, [
                {
                  offset: this.props.data.length > 3 ? 0.98 : 1,
                  color: '#26a0fc',
                },
                {
                  offset: this.props.data.length === 3 ? 1 : 0.98,
                  color: '#FF0000',
                },
              ]
            ),
          },
          // Optional: Area under the line (gradient fill)
          areaStyle: {
            opacity: 0.1,  // Adjust opacity if you want the area to be visible
            color: new echarts.graphic.LinearGradient(
              0, 0, 1, 0, [
                {
                  offset: this.props.data.length > 3 ? 0.98 : 1,
                  color: '#26a0fc',
                },
                {
                  offset: this.props.data.length === 3 ? 1 : 0.98,
                  color: '#FF0000',
                },
              ]
            ),
          },
          markArea: {
            itemStyle: {
              opacity: 0.8
            },
            data: [
              // First range
              [{
                
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[4],
              }, {
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[5], // Adding 1/8th
                itemStyle: {
                  color: 'rgb(178,117,175)'
                }
              }],
              // Second range
              [{
              
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[3],
              }, {
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[4],
                itemStyle: {
                  color: 'rgb(243,93,80)'
                }
              }],
              // Third range
              [{
              
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[2],
              }, {
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[3],
                itemStyle: {
                  color: 'rgb(253,141,20)'
                }
              }],
              // Fourth range
              [{
                
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[1],
              }, {
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[2],
                itemStyle: {
                  color: 'rgb(255,174,66)'
                }
              }],
              // Fifth range
              [{
               
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[0],
              }, {
                yAxis: this.props.flow_returnPer.sort((a, b) => a - b)[1],
                itemStyle: {
                  color: 'rgb(255,227,109)'
                }
              }]
            ]
          },
          
        }],
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
        ],
       
        
        
      }
    };
  }
  updateChartSize = () => {
    this.setState({
      height: Math.min(360, window.innerHeight * 0.9),
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateChartSize);
  }

  componentWillUnmount() {
    window.addEventListener("resize", this.updateChartSize);
  }
  handleMinimizeClick = () => {
    this.props.toggleVisibleGraphPanel();
  };
  exportToCSV = () => {
    const { data, title } = this.props;
  
    // Convert data to CSV format
    let csvContent = `"Date","Inflow (cusecs)"\n`;
   

    data.forEach(([timestamp, value]) => {
      let prefix;
    
   
        prefix = moment(timestamp).format("DD MMM YYYY");
      
      const formattedValue = value;
      csvContent += `${prefix},${formattedValue}\n`;
    });
  
    // Create a Blob containing the CSV data
    const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
  
    // Create a link element and trigger a download
    const a = document.createElement('a');
    a.href = URL.createObjectURL(csvBlob);
    a.download = this.props.rname[1].split("(")[0].replace(" ", "_") + "_ISI_"+`${this.props.date}.csv`;
    a.click();
  };

  render() {
    return (
      <div>
        <div className="legend-container" style={{ display: "grid", justifyContent: "space-between", position: "relative" }}>
          <div className="legend-item">
            <strong style={{ padding: '0px 0px' }}>Return Periods</strong>
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(255,227,109)' }}></span>
            5 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[0])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(255,174,66)' }}></span>
            10 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[1])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(253,141,20)' }}></span>
            20 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[2])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(243,93,80)' }}></span>
            30 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[3])}
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: 'rgb(178,117,175)' }}></span>
            50 Years: {Math.trunc(this.props.flow_returnPer.sort((a, b) => a - b)[4])}
          </div>
          <div className="legend-item" style={{ paddingTop: "10px" }}>
            <span className="legend-line" style={{ backgroundColor: '#26a0fc' }}></span>
            <strong>Inseason<br />Inflow {moment(this.props.curr_date).format("YYYY")}</strong>
          </div>
          <div className="legend-item">
            <span className="legend-line" style={{ backgroundColor: 'red' }}></span>
            <strong>Forecasted <br />Inflow {moment(this.props.curr_date).format("DD MMM")}</strong>
          </div>
        </div>

        <ReactECharts
          option={this.state.options}
         // style={{ height: Math.min(380, window.innerHeight * 0.9), width: '100%' }}
         style={{ height: '350px', width: '100%' }}

        />
      </div>
    );
  }
}

export default GradientChart;
